module.exports = __webpack_public_path__ + "static/media/8OLA30.e06fb81a.jpg";